import React from 'react'
import './Footer.sass'
import Logo from '../../ui/Logo/Logo'
import SocialLinks from '../Top/SocialLinks/SocialLinks'
import PhoneLinks from '../Top/PhoneLinks/PhoneLinks'
import EmailLink from '../Top/EmailLink/EmailLink'
import { NavLink } from 'react-router-dom'
import Icon from '../../ui/Icon/Icon'
import { NavHashLink } from 'react-router-hash-link'
import scrollWithOffset from '../../ui/ScrollToTop/scrollWithOffset'
import BusyHours from '../Top/BusyHours/BusyHours'
import SiteNavLink from '../Nav/SiteNavLink'

function Footer() {
  return (
    <footer id="contacts" className="Footer">
      <div className="Main DefaultContainer">
        <div className="LogoBlock">
          <Logo />
          <SiteNavLink title="Дозвільні документи" path="/docs" />
        </div>
        <div className="ContactBlock">
          <div className="AdditionalContacts">
            <PhoneLinks useTime={false} />

            <a href="tel:+38 (067) 000-03-77">+38 (067) 000-03-77</a>
            <a href="tel:+38 (077) 000-08-28">+38 (077) 000-08-28</a>
            <p className="Title">Клієнт.менеджер</p>
            <a href="tel:+38 (097) 000-05-11">+38 (097) 000-05-11</a>
            <p className="Title">Центральний офіс</p>
          </div>
          <div className="AdditionalContacts">
            <a href="tel:+38 (096) 000-05-11">+38 (096) 000-05-11</a>
            <p className="Title">Бухгалтерія</p>
            <a href="tel:+38 (068) 181-80-80">+38 (068) 181-80-80</a>
            <p className="Title">Керівник</p>
          </div>
          <div className="FooterAddress">
            <BusyHours />
            <div className="Address">
              <Icon name="map-marker-alt" weight="solid" />
              <div>
                <a
                  href="https://www.google.com/maps?q=Сиріус+Захід,+вулиця+Ґрунтова,+5,+Львів,+Львівська+область,+79066&ftid=0x473ae9a82f628221:0xf1542843b43d39f6&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI1LjE5LjEuNzU0OTg3NTEyMBgAIIgnKmMsOTQyMjQ4MjUsOTQyMjcyNDcsOTQyMjcyNDgsOTQyMzExODgsNDcwNzE3MDQsNDcwNjk1MDgsOTQyMTg2NDEsOTQyMDMwMTksNDcwODQzMDQsOTQyMDg0NTgsOTQyMDg0NDdCAlVB&skid=0f55803e-4e4e-444e-a810-1efbf4c10300&g_st=com.google.maps.preview.copy"
                  target="blank"
                  className="MapActiveLink"
                >
                  <span>м. Львів, вул. Грунтова 5</span>
                </a>
                <br />
                <a
                  href="https://www.google.com/maps?q=Сиріус+Захід,+вулиця+Ґрунтова,+5,+Львів,+Львівська+область,+79066&ftid=0x473ae9a82f628221:0xf1542843b43d39f6&entry=gps&lucs=,94224825,94227247,94227248,94231188,47071704,47069508,94218641,94203019,47084304,94208458,94208447&g_ep=CAISEjI1LjE5LjEuNzU0OTg3NTEyMBgAIIgnKmMsOTQyMjQ4MjUsOTQyMjcyNDcsOTQyMjcyNDgsOTQyMzExODgsNDcwNzE3MDQsNDcwNjk1MDgsOTQyMTg2NDEsOTQyMDMwMTksNDcwODQzMDQsOTQyMDg0NTgsOTQyMDg0NDdCAlVB&skid=0f55803e-4e4e-444e-a810-1efbf4c10300&g_st=com.google.maps.preview.copy"
                  target="blank"
                  className="MapActiveLink"
                >
                  <span>м. Львів, вул. Рахівська 19</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="FooterNav ">
        <div className="FooterLinks DefaultContainer">
          <SiteNavLink
            title="Металобрухт"
            path="/service/V96y8rbcLGplmTd9nDzQ"
          />
          <SiteNavLink
            title="Вивіз буд. відходів"
            path="/service/5OCoeWQP6BE3auSr2QmQ"
          />
          <SiteNavLink
            title="Демонтаж будівель"
            path="/service/SiFdfPQeUuzWrwNKwTtf"
          />
          <SiteNavLink title="Оренда спецтехніки, контейнерів" path="#" />
          <SiteNavLink
            title="Макулатура, склобій"
            path="/service/6EIdKtHPBtnGO5xSXC4e"
          />
          <SiteNavLink title="Прайс" path="/price" />
          <SiteNavLink title="Дозвільні документи" path="/docs" />
        </div>
      </div> */}
      <div className="Copyrights DefaultContainer">
        © 2025 Всі права захищено.
      </div>
    </footer>
  )
}

export default Footer
